export const ROUTES = {
  edit: (id: string) => `/sales-enablement/my-marketing-materials/${id}`,
  newMaterial: (id: string) =>
    `/sales-enablement/my-marketing-materials/new/${id}`,
  printArchive: `/sales-enablement/print-archive`,
  printOrderDetails: (id: string) => `/sales-enablement/print-archive/${id}`,
};
